import type { Bundle } from '../types';

/**
 * Returns a new bundle where every value is character-reversed.
 *
 * en-XB simulates bidirectional (RTL) rendering without needing real Arabic
 * or Hebrew content. Reversed strings expose layout bugs caused by hardcoded
 * LTR assumptions: truncation on the wrong side, misaligned icons, broken
 * flex/grid layouts that assume left-to-right reading order.
 *
 * Use with `?locale=en-XB` in dev mode. Because reversal happens at the
 * string level, ICU format patterns ({count, plural, ...}) are also reversed —
 * this is intentional: it tests whether the UI handles unusual string shapes.
 */
export function getXBBundle(base: Bundle): Bundle {
  return Object.fromEntries(
    Object.entries(base).map(([k, v]) => [k, v.split('').reverse().join('')]),
  );
}
